import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "736",
  height: "8.002"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M735.999 8h-1a6.953 6.953 0 0 0-2.053-4.947A6.952 6.952 0 0 0 727.999 1h-720a7.008 7.008 0 0 0-7 7h-1a8.008 8.008 0 0 1 8-8h720a8.01 8.01 0 0 1 8 8Z",
      fill: "#c2c2c2"
    }, null, -1)
  ]))]))
}
export default { render: render }